import { useTheme } from '@emotion/react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Menu, MenuItem, Stack } from '@mui/material';
import { ErrorBoundaryXcala } from '../../../ErrorBoundaryXcala';
import {
  BoxMenu,
  BoxMenuItem,
  Circle,
  ListItemButtonMenu,
  ListItemIcons,
  StackMiniDrawer,
  TypographyMenuItem,
} from '../Layouts/StyledComponentsMenu';
import { WalletClosedDrawer } from './WalletClosedDrawer';

export const MiniDrawerItem = ({
  menuItem,
  handleClick,
  handleClose,
  openMenu,
  anchorEl,
  navigate,
  handleNavigateWallet,
  activeItem,
  setActiveItem,
}) => {
  const theme = useTheme();

  const handleItemClick = (event, name) => {
    handleClick(event, name);
  };

  const isActive = activeItem?.toLowerCase() === menuItem.name.toLowerCase();

  return (
    <StackMiniDrawer>
      <ListItemButtonMenu
        onClick={event => handleItemClick(event, menuItem.name)}
        sx={{
          backgroundColor: isActive ? theme.palette.white.main : theme.palette.primary.main,
          color: isActive ? theme.palette.primary.main : theme.palette.white.main,
          mt: '6px',
          '&:hover': {
            backgroundColor: isActive ? theme.palette.grey[300] : 'transparent',
          },
        }}>
        <ListItemIcons
          sx={{
            color: isActive ? theme.palette.primary.dark : theme.palette.white.main,
          }}>
          {menuItem.icon}
          <KeyboardArrowRightIcon
            sx={{
              color: isActive ? theme.palette.primary.dark : theme.palette.white.main,
            }}
          />
        </ListItemIcons>
      </ListItemButtonMenu>

      <Box>
        <Menu
          anchorEl={anchorEl}
          open={openMenu === menuItem.name}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
          transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          sx={{ borderRadius: '8px', ml: '36px' }}>
          {menuItem.subMenu.some(
            subItem =>
              subItem.btnNameSub !== 'Caja Disponible' &&
              subItem.btnNameSub !== 'Dinero en Tránsito',
          ) && (
            <BoxMenu>
              {menuItem.subMenu
                .filter(
                  subItem =>
                    subItem.btnNameSub !== 'Caja Disponible' &&
                    subItem.btnNameSub !== 'Dinero en Tránsito',
                )
                .map(subItem => (
                  <BoxMenuItem key={subItem.id}>
                    <MenuItem
                      onClick={() => {
                        navigate(subItem.url);
                        setActiveItem(menuItem.name.toLowerCase());
                        handleClose();
                      }}
                      sx={{ display: 'flex', flexDirection: 'row' }}>
                      {['Productos', 'Mi cuenta'].includes(menuItem.name) && (
                        <Circle className='circle-bullet' />
                      )}
                      <Stack>
                        <TypographyMenuItem marginLeft='8px'>
                          {subItem.btnNameSub}
                        </TypographyMenuItem>
                      </Stack>
                    </MenuItem>
                  </BoxMenuItem>
                ))}
            </BoxMenu>
          )}

          {menuItem.subMenu.some(
            subItem =>
              subItem.btnNameSub === 'Caja Disponible' ||
              subItem.btnNameSub === 'Dinero en Tránsito',
          ) && (
            <ErrorBoundaryXcala>
              <WalletClosedDrawer
                menuItem={menuItem}
                navigate={navigate}
                handleClose={handleClose}
                handleNavigateWallet={handleNavigateWallet}
                setActiveItem={setActiveItem}
              />
            </ErrorBoundaryXcala>
          )}
        </Menu>
      </Box>
    </StackMiniDrawer>
  );
};
